// Recommendations.js - Component for Recommendations (Nouvelle version avec 1 seul champ : Bilan)
import React from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import UserMin from '../../components/plans/UserMin';

const Recommendations = ({ recommendations, setRecommendations, handleCreateWeekPlan, prevStep, selectedClient, userPreferences }) => (
  <>
    <UserMin selectedClient={selectedClient} userPreferences={userPreferences} />

    <Typography variant="h6" sx={{ mb: 2, mt: 2 }}>
      Bilan de la semaine
    </Typography>
    <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
      Notez ici vos recommandations générales pour le client : objectifs, points d'attention, conseils nutrition/hydratation, gestion du stress, etc.
    </Typography>

    <TextField
      label="Bilan"
      fullWidth
      multiline
      rows={8}
      value={recommendations.bilan || ''}
      onChange={(e) => setRecommendations({ ...recommendations, bilan: e.target.value })}
      placeholder="Ex: Attention à l'hydratation cette semaine. Objectif : augmenter progressivement le volume d'entraînement. Bien dormir avant les jours INTENSIF."
      sx={{ marginBottom: 3 }}
    />

    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Button variant="contained" color="secondary" onClick={prevStep} sx={{ marginRight: 2 }}>
        Retour
      </Button>
      <Button variant="contained" color="primary" onClick={handleCreateWeekPlan}>
        {window.location.pathname.includes('edit') ? 'Sauvegarder' : 'Créer le programme'}
      </Button>
    </Box>
  </>
);

export default Recommendations;
